import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import dlt from '../../../assets/images/dlt.png';
import { SHIPMENTSAVEINVOICECATEGORY, SHIPMENTINVOICECATEGORIESSELECT, ADDRESSBOOKDROPDOWN } from '../../../Utils/conts.js';
import { withRFSToken } from '../../../Services/axios';
import { toast } from 'react-toastify';
import Trash from "../../../assets/images/trash.png";
import Edit from "../../../assets/images/edit.png";
import Select from 'react-select';
import { faFileImport, faDownload, faUpload } from '@fortawesome/free-solid-svg-icons';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
const currencyOptions = [

    { value: "EUR", label: "EUR (€) - Euro" },
    { value: "USD", label: "USD ($) - US Dollar" },
    { value: "PHP", label: "PHP (₱) - Philippine Peso" },
    { value: "JPY", label: "JPY (¥) - Japanese Yen" },
    { value: "GBP", label: "GBP (£) - British Pound" },
    { value: "AUD", label: "AUD (A$) - Australian Dollar" },
    { value: "CHF", label: "CHF (Fr.) - Swiss Franc" },
    { value: "CAD", label: "CAD (C$) - Canadian Dollar" },
    { value: "MXN", label: "MXN ($) - Mexican Peso" },
    { value: "CNY", label: "CNY (¥) - Chinese Yuan" },
    { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar" },
    { value: "SEK", label: "SEK (kr) - Swedish Krona" },
    { value: "RUB", label: "RUB (₽) - Russian Ruble" },
    { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar" },
    { value: "NOK", label: "NOK (kr) - Norwegian Krone" },
    { value: "SGD", label: "SGD (S$) - Singapore Dollar" },
    { value: "TRY", label: "TRY (₺) - Turkish Lira" },
    { value: "KRW", label: "KRW (₩) - South Korean Won" },
    { value: "ZAR", label: "ZAR (R) - South African Rand" },
    { value: "BRL", label: "BRL (R$) - Brazilian Real" },
    { value: "INR", label: "INR (₹) - Indian Rupee" },
    { value: "SAR", label: "SAR (﷼) - Saudi Riyal" },
    { value: "DKK", label: "DKK (kr) - Danish Krone" },
    { value: "RON", label: "RON (lei) - Romanian Leu" },
    { value: "XAF", label: "XAF (Fr) - Central African CFA Franc" },
    { value: "XOF", label: "XOF (Fr) - West African CFA Franc" },
    { value: "DOP", label: "DOP (RD$) - Dominican Peso" },
    { value: "HTG", label: "HTG (G) - Haitian Gourde" },
    { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar" },
    { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar" },
    { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar" },
    { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder" },
    { value: "COP", label: "COP (COL$) - Colombian Peso" },
    { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights" },
    { value: "XBT", label: "XBT (₿) - Bitcoin" },
    { value: "WGH", label: "WGH - West German Hard Currency" }
];

const vatRates = [
    { value: '', label: 'Select VAT Rate', percent: 0 },
    { value: '0', label: '0% - Exempt', percent: 0 },
    { value: '5', label: '5% - Reduced Rate', percent: 5 },
    { value: '12', label: '12% - Standard Rate', percent: 12 },
    { value: '18', label: '18% - Standard Rate', percent: 18 },
    { value: '20', label: '20% - General Rate', percent: 20 },
    { value: '21', label: '21% - General Rate', percent: 21 },
];

const defaultRow = {
    no: 1,
    category: '',
    costs: '',
    ttl: '',
    vat: '20',
    vatAmount: 0,
};

const StationRateSettings = () => {
    // Set EUR as default currency and 20% VAT as default
    const [addCategoryModal, setAddCategoryModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState('eur');
    const [vatType, setVatType] = useState('exclude'); // 'exclude' or 'include'
    const [rows, setRows] = useState([{ ...defaultRow }]);
    const gridRefs = useRef(null);
    const [allData, setAlldata] = useState(null);
    const [addressBookList, setAddressBookList] = useState(null);

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const gridRef = useRef(null);
    const [gridData, setGridData] = useState([]);
    const [gridSelect, setGridSelect] = useState([]);

    useEffect(() => {
        if (isMounted.current) return;
        addressBookDropdown();
        setIsLoading(false);
        console.log('hhhh');

        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    // Get currency symbol
    const getCurrencySymbol = () => {
        const found = currencyOptions.find(opt => opt.value === selectedCurrency);
        return found ? found.symbol : '';
    };

    // Calculate VAT Amount for a row
    const calculateVatAmount = (costs, vatValue) => {
        const vatObj = vatRates.find(v => v.value === vatValue);
        const percent = vatObj ? vatObj.percent : 0;
        const costNum = parseFloat(costs) || 0;
        return ((costNum * percent) / 100).toFixed(2);
    };

    const addressBookDropdown = async () => {
        try {
            const res = await withRFSToken.get(ADDRESSBOOKDROPDOWN)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setAddressBookList(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Calculate Subtotal, VAT Total, and Grand Total
    const getSubtotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.costs) || 0), 0);
    const getVatTotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.vatAmount) || 0), 0);
    const getGrandTotal = () => {
        if (vatType === 'exclude') {
            return getSubtotal() + getVatTotal();
        } else {
            return getSubtotal();
        }
    };

    // Handle input change for a row
    const handleRowChange = (idx, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === idx) {
                let updatedRow = { ...row, [field]: value };
                // Recalculate VAT Amount if costs or vat changes
                if (field === 'costs' || field === 'vat') {
                    updatedRow.vatAmount = calculateVatAmount(
                        field === 'costs' ? value : row.costs,
                        field === 'vat' ? value : row.vat
                    );
                }
                return updatedRow;
            }
            return row;
        });
        setRows(updatedRows);
    };

    // Add a new row
    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                ...defaultRow,
                no: rows.length + 1,
            },
        ]);
    };

    // Delete a row
    const handleDeleteRow = (idx) => {
        if (rows.length === 1) return;
        const updatedRows = rows.filter((_, i) => i !== idx).map((row, i) => ({ ...row, no: i + 1 }));
        setRows(updatedRows);
    };

    // On currency change, update state and force re-render for symbol
    const handleCurrencyChange = (e) => {
        setSelectedCurrency(e.target.value);
    };

    // Open/close modal
    const handleClose = () => setAddCategoryModal(false);
    const handleShow = () => setAddCategoryModal(true);

    const handleSave = async () => {
        const payload = rows.map(row => ({
            no: row.no,
            category: row.category,
            cost: parseFloat(row.costs) || 0,
            ttl: row.ttl ? parseFloat(row.ttl) : null,
            vat: row.vat ? parseFloat(row.vat) : null,
            vat_amount: row.vatAmount ? parseFloat(row.vatAmount) : null,
            currency: selectedCurrency,
            vat_applicable: vatType === 'exclude' ? 0 : 1,
            customer: row.customer || null,
        }));

        console.log(" handleSave payload" , payload);
        // try {
        //     const res = await withRFSToken.post(SHIPMENTSAVEINVOICECATEGORY, { categories: payload })
        //         .then(function (res) {
        //             if (res.data.response_code == 200) {
        //                 toast.success(res.data.response_msg);
        //                 // loadGrid();
        //                 setAddCategoryModal(false);
        //                 window.$(gridRef.current).jqxGrid('updatebounddata');
        //             } else {
        //                 toast.error(res.data.response_msg);
        //             }
        //             setAddCategoryModal(false);
        //         });

        // } catch (error) {
        //     console.error('Error sending request:', error);
        // }
    };

    const loadGrid = () => {
        // const token = 'Bearer ' + localStorage.RFS;
        jqxCookieCall()
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}shipment/get-invoice-categories`,
            root: 'response_data',
            cache: false,
            datafields: [
                { name: 'category', type: 'string' },
                { name: 'cost', type: 'string' },
                { name: 'created_by', type: 'string' },
                { name: 'created_on', type: 'string' },
                { name: 'currency', type: 'string' },
                { name: 'id', type: 'string' },
                { name: 'no', type: 'string' },
                { name: 'org_id', type: 'string' },
                { name: 'status', type: 'string' },
                { name: 'total_amount', type: 'string' },
                { name: 'ttl', type: 'string' },
                { name: 'updated_on', type: 'string' },
                { name: 'vat', type: 'string' },
                { name: 'vat_amount', type: 'string' },
                { name: 'vat_applicable', type: 'string' },
                { name: 'customer', type: 'string' },
                { name: 'customer_details', type: 'string' },
            ],
            // beforeSend: (jqXHR) => {
            //     jqXHR.setRequestHeader('Authorization', token);
            // },
            filter: function (allfilters) {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: function (data) {
                // if (Array.isArray(data.response_data)) {
                //     setRows(
                //         data.response_data.map((row, idx) => ({
                //             no: row.no || idx + 1,
                //             category: row.category || '',
                //             costs: row.cost || '',
                //             ttl: row.ttl || '',
                //             vat: row.vat !== undefined ? String(row.vat) : '20',
                //             vatAmount: row.vat_amount || 0,
                //             currency: row.currency || 'eur',
                //             vat_applicable: row.vat_applicable !== undefined ? row.vat_applicable : 1,
                //         }))
                //     );
                // }
                setAlldata(data.response_data);
            }
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
            // {
            //     text: 'Action', datafield: '', width: '8%', filtertype: '',
            //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            //         return `<div class="grid_actions"><img class="door_edit" src="${Edit}"/><img class="door_delete" src="${Trash}"/></div>`;
            //     }
            // },
            {
                text: 'Status',
                datafield: 'status',
                width: '10%',
                cellsrenderer: (rowIndex, dataField, cellValue) => {
                    const isActive = cellValue === '1' || cellValue === 1;
                    const status = isActive ? 'Active' : 'Inactive';
                    const colorClass = isActive ? 'text-success' : 'text-danger';

                    return `<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px" ><span class="${colorClass} ">${status}</span></div>`;
                }
            },
            { text: 'Currency', datafield: 'currency', width: '10%' },
            // { text: 'VAT Applicable', datafield: 'vat_applicable', width: '10%' },
            {
                text: 'VAT Applicable',
                datafield: 'vat_applicable',
                width: '10%',
                cellsrenderer: (rowIndex, dataField, cellValue) => {
                    const text = cellValue == '0' || cellValue == 0 ? 'Exclude GST' : 'Include GST';
                    return `<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px">${text}</div>`;
                }
            },
            { text: 'Number', datafield: 'no', width: '5%' },
            {
                text: 'Customer',
                datafield: 'customer_details',
                width: '12%',
                cellsrenderer: (rowIndex, dataField, cellValue) => {
                    const name = cellValue?.name || 'N/A';
                    const displayName = name.length > 20 ? name.slice(0, 20) + '...' : name;
                    return `<div class="jqx-grid-cell-left-align" style="margin-top: 12px; margin-left:5px" title="${name}">${displayName}</div>`;
                }
            },
            { text: 'Category', datafield: 'category', width: '10%' },
            { text: 'Cost', datafield: 'cost', width: '8%' },
            { text: 'TTL', datafield: 'ttl', width: '8%' },
            { text: 'VAT %', datafield: 'vat', width: '8%' },
            { text: 'VAT Amount', datafield: 'vat_amount', width: '10%' },
        ];
        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pageable: true,
            selectionmode: 'checkbox',
            pageSize: 50,
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
            ready: function () {
                // const rows = window.$(gridRefs.current).jqxGrid('getrows');
                // rows.forEach((row, idx) => {
                //     if (row.status === '1' || row.status === 1) {
                //         window.$(gridRefs.current).jqxGrid('selectrow', idx);
                //     }
                // });
            }
        };

        window.$(gridRefs.current).jqxGrid(gridOptions);
        // window.$(gridRefs.current).off('click', '.door_edit').on('click', '.door_edit', function () {
        //   const rowDiv = window.$(this).closest('[role="row"]');
        //   const rowIndex = window.$(rowDiv).attr('row-id');
        //   const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
        //   setEditDeleteData({
        //     warehouse_name: rowData.name,
        //     warehouse_type: rowData.warehouse_type,
        //     name_contains: rowData.name_contains,
        //     warehouse_id: rowData.id,
        //     address_contains: rowData.address_contains,
        //   });
        //   setAddEditWareHousemodal(true);
        // });
        // window.$(gridRefs.current).off('click', '.door_delete').on('click', '.door_delete', function () {
        //   const rowDiv = window.$(this).closest('[role="row"]');
        //   const rowIndex = window.$(rowDiv).attr('row-id');
        //   const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
        //   setEditDeleteData(rowData);
        //   setConfModal(true);
        // });
    };

    // const handleActiveInvoice = async () => {
    //     const selectedIndexes = window.$(gridRefs.current).jqxGrid('getselectedrowindexes');
    //     if (!selectedIndexes || selectedIndexes.length === 0) {
    //         toast.error("Please select at least one invoice.");
    //         return;
    //     }
    //     // Get row data for each selected index
    //     const filterStatus = selectedIndexes.filter(i => i.status == 0)
    //     console.log("filterStatus", filterStatus);
    //     const selectedIds = selectedIndexes.map(idx => {
    //         const row = window.$(gridRefs.current).jqxGrid('getrowdata', idx);
    //         return row.id;
    //     }).filter(Boolean);
    //     console.log("Selected IDs:", selectedIds);
    //     console.log("selectedIndexes", selectedIndexes);
    //     // try {
    //     //     const res = await withRFSToken.post(SHIPMENTINVOICECATEGORIESSELECT, { categories_ids: selectedIds })
    //     //         .then(function (res) {
    //     //             if (res.data.response_code == 200) {
    //     //                 toast.success(res.data.response_msg);
    //     //                 loadGrid();
    //     //                 setTimeout(() => {
    //     //                     window.$(gridRefs.current).jqxGrid('clearselection');
    //     //                 }, 1000);
    //     //             } else {
    //     //                 toast.error(res.data.response_msg);
    //     //             }
    //     //             setAddCategoryModal(false);
    //     //         });

    //     // } catch (error) {
    //     //     console.error('Error sending request:', error);
    //     // }
    // };
    const handleActiveInvoice = async (status) => {
        let filterStatus;
        let payload = {}
        if (status == 1) {
            const alreadyActive = gridSelect.filter(i => i.status == 1);
            if (alreadyActive.length === gridSelect.length) {
                toast.success("Selected categories are already active.");
                return;
            }
            filterStatus = gridSelect.filter(i => i.status == 0).map(d => d.id);
            payload = { active_categories_ids: filterStatus }
        } else if (status == 0) {
            const alreadyInactive = gridSelect.filter(i => i.status == 0);
            if (alreadyInactive.length === gridSelect.length) {
                toast.error("Selected categories are already inactive.");
                return;
            }
            filterStatus = gridSelect.filter(i => i.status == 1).map(d => d.id)
            payload = { inactive_categories_ids: filterStatus }
        }
        // console.log("filterStatus", filterStatus);
        try {
            const res = await withRFSToken.post(SHIPMENTINVOICECATEGORIESSELECT, payload)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        // loadGrid();
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([])
                        window.$(gridRef.current).jqxGrid('updatebounddata');
                    } else {
                        toast.error(res.data.response_msg);
                    }
                    setAddCategoryModal(false);
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };
    // useEffect(() => {
    //     addressBookDropdown();
    //     // Initialize the grid
    //     // loadGrid();
    // }, []);

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()

            const source = {
                datatype: 'json',

                root: 'response_data',
                cache: false,
                datafields: [
                  { name: 'services', type: 'string' },
                  { name: 'airport', type: 'string' },
                  { name: 'rate', type: 'string' },
                  { name: 'units', type: 'string' },
                  { name: 'total', type: 'string' },
                ],
                url: `${process.env.REACT_APP_RFS_URL}shipment/get-invoice-categories`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRef.current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    // source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                // root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                { text: 'Service', datafield: 'services', width: '10%', filterType:'input' },
                { text: 'Airport', datafield: 'airport', width: '10%', filterType:'input' },
                { text: 'Rate', datafield: 'rate', width: '10%', filterType:'input' },
                { text: 'Units', datafield: 'units', width: '10%', filterType:'input' },
                { text: 'Total', datafield: 'total', width: '10%', filterType:'input' },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // rendered: function () {
                //   const rows = window.$(gridRef.current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(gridRef.current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                const dataToSend = {
                    uld_number: rowData.uld_number,
                    type_code: rowData.type_code,
                    serial_number: rowData.serial_number,
                    owner_code: rowData.owner_code,
                    condition_code: rowData.condition_code,
                    asset_type: rowData.asset_type == 'Y' ? false : true
                };
                // setEditData(dataToSend);
                // setShowEdit(true);
            });
            // window.$(gridRef.current).on('click', '.screen', function () {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            //     console.log("🚀 ~ rowData:", rowData)
            //     setIsModal(true)
            // });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            // window.$(gridRef.current).off('cellclick');
            // window.$(gridRef.current).on('cellclick', (event) => {
            //     const args = event.args.row.bounddata;
            //     if (![4, 10].includes(event.args.columnindex)) {
            //         if (gridSelect) {
            //             gridSelect.forEach(item => {
            //                 const selectedRowBoundIndex = item.boundindex;
            //                 window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            //             });
            //         }
            //         // loadDetails(args.uld_number);
            //         setSelectedRowData(args)
            //         setTimeout(() => {
            //             window.$(gridRef.current).jqxGrid('refresh');
            //         }, 30);
            //     }
            // });
            // }
        }
    }, [gridData]);

    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
            {/* {console.log('gridSelect', gridSelect)} */}
            {/* <div className=""> */}
                {/* <Header page_type='fsm' logo_url='/ForwarderShipments/Quotation' /> */}
                {/* <Header page_type='fsm' logo_url={SBack ? SBack : '/ForwarderShipments/Quotation'} />
                <div className="main-panel">
                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                <div className='category_invoice_title'>
                                    <h4>Station Rate Settings</h4>
                                    <p>Set your notification preferences for when you are in or away from the dashboard</p>
                                </div>
                                <div className='d-flex justify-content-start mb-3'>
                                    <Button variant="primary me-2" onClick={handleShow} ><span className='me-2'><FontAwesomeIcon icon={faPlus} /></span>Add Station Rate</Button>
                                    {/* <Dropdown>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                            <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handleActiveInvoice('1')}>Active Invoice</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleActiveInvoice('0')}>Inactive Invoice</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown> */}
                                     <div className='ms-auto'><Button onClick={() => setShowModal(true)}><FontAwesomeIcon icon={faFileImport} /> Upload</Button></div>
                                </div>
                                <div className='trashdonload'>
                                    {!isLoading && <div ref={gridRef} className='setting_bookinggrid' ></div>}
                                </div>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}

            <Modal show={addCategoryModal} onHide={handleClose} className='addfrom add_category_modal' centered size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Station Rate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex align-items-center justify-content-end category_btn_grp'>
                        <span>Amount in </span>
                        <Form.Select
                            size="sm"
                            className="euro_amount_select"
                            value={selectedCurrency}
                            onChange={handleCurrencyChange}
                        >
                            {currencyOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </Form.Select>
                        {/* <Button
                            variant="outline-secondary"
                            className={vatType === 'exclude' ? 'active' : ''}
                            onClick={() => setVatType('exclude')}
                        >
                            Excluding VAT
                        </Button>
                        <Button
                            variant="outline-secondary"
                            className={vatType === 'include' ? 'active' : ''}
                            onClick={() => setVatType('include')}
                        >
                            Including VAT
                        </Button> */}
                    </div>
                    <hr />
                    <div className='add_category_modal_table text-center'>
                        <Table borderless responsive>
                            <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>Customer</th>
                                    <th>Category</th>
                                    <th>Costs</th>
                                    <th>TTL</th>
                                    <th>VAT</th>
                                    <th>VAT Amount</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                className='form-control'
                                                value={row.no}
                                                onChange={e => handleRowChange(idx, 'no', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Select
                                                options={addressBookList}
                                                onChange={(selected) => {
                                                    handleRowChange(idx, 'customer', selected.value);
                                                }}
                                                placeholder="Customer"
                                                className='down_selct'
                                                name="customer"
                                                value={addressBookList?.find(option => option.value === row.customer)}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                className='form-control'
                                                value={row.category}
                                                onChange={e => handleRowChange(idx, 'category', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                className='form-control'
                                                value={row.costs}
                                                onChange={e => handleRowChange(idx, 'costs', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                className='form-control'
                                                value={row.ttl}
                                                onChange={e => handleRowChange(idx, 'ttl', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <Form.Select
                                                size="sm"
                                                className="vat_select"
                                                value={row.vat}
                                                onChange={e => handleRowChange(idx, 'vat', e.target.value)}
                                            >
                                                {vatRates.map(opt => (
                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                ))}
                                            </Form.Select>
                                        </td>
                                        <td>{row.vatAmount}</td>
                                        <td>
                                            {rows.length > 1 && (
                                                <img
                                                    src={dlt}
                                                    alt='dlt'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleDeleteRow(idx)}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className='dimension_add text-end'>
                            <button type="button" className="btn btn-primary" onClick={handleAddRow}>+ Add Row</button>
                        </div>
                    </div>
                    {/* <div className='subtotal_dv'>
                        <p className='mb-2'><span className='me-5'>Subtotal </span><span>{getCurrencySymbol()} {getSubtotal().toFixed(2)}</span></p>
                        <p className='mb-2'><span className='me-5'>VAT Total </span><span>{getCurrencySymbol()} {getVatTotal().toFixed(2)}</span></p>
                        <p className='mb-2'><span className='me-5'>Total - </span><span className='fw-bold'>{getCurrencySymbol()} {getGrandTotal().toFixed(2)}</span></p>
                    </div> */}
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleSave}>Save</Button>
                    </div>
                </Modal.Footer>
            </Modal>
                        <Modal show={showModal} onHide={() => setShowModal(false)} className='addfrom change_type' centered>
                            <Modal.Header closeButton>
                            </Modal.Header>
                            <Modal.Body>
                                <h3>Import Excel</h3>
                                <p>Upload the filled in template to add ULDs.</p>
                                <div className='asset_midle'>
                                    {/* <div className='mb-4'>
                                        <Select
                                            options={currencies}
                                            onChange={(e) => setModalContent(e.value)}
                                            // placeholder="--"
                                            className="autoslct mx-auto"
                                            name="air_freight_currency"
                                            value={currencies.find(option => option.value === modalContent) || ''}
                                        />
                                    </div> */}
                                    <div className='upload_tmpl'>
                                        <button 
                                        // onClick={handleDownloadClick}
                                        >

                                            <FontAwesomeIcon icon={faDownload} />
                                            <span>Download Template (Excel) </span>
                                        </button>
                                        <div className="form-group inputDnD">
                                            <FontAwesomeIcon icon={faUpload} />
                                            <input
                                                type="file" className="form-control-file "
                                                id="inputFile"
                                                // accept=".xlsx, .xls, .csv"
                                                // onChange={handleFileChange}
                                                data-title="Upload your file (Excel)" />
            
                                            {/* {fileData && (
                                                <div>
                                                    <h4>File Data:</h4>
                                                    <pre>{fileData}</pre>
                                                </div>
                                            )} */}
                                        </div>
                                    </div>
            
                                    {/* {fileName && (
                                        <div className='rafilname'>
                                            <p>File Name: {fileName}</p>
                                        </div>
                                    )} */}
            
            
                                    {/* <Form.Control
                                        type="file"
                                        onChange={handleFileChange}
                                        accept=".xlsx, .xls, .csv"
                                    /> */}
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <div className='d-flex w-50 mx-auto are_bottom'>
                                    <Button variant="secondary" onClick={() => console.log("clicked")}>
                                        Cancel
                                    </Button>
                                    <Button variant="primary" onClick={console.log("clicked")}>
                                        Upload
                                    </Button>
                                </div>
                            </Modal.Footer>
                        </Modal>
        </>
    );
};

export default StationRateSettings;